import React, { Component } from 'react';
import { Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';
import QRCode from 'qrcode.react';
import { renderToStaticMarkup } from 'react-dom/server';

import CustomModal from "../../../components/Modal/CustomModal";
import ModalReports from '../../../components/Reportes/ModalReports';

import { AceptarTransaccion, NoAceptarTransaccion } from '../../../funciones/AdministracionFunction';
import { SvgToPng } from "../../../funciones/AdmisionFunction";
import { formatNumber, formatReconver } from "../../../funciones/GeneralFunctions";

import ReciboDePago from '../../../components/Reportes/ReciboDePago';
import DatosInscripcion from "../../Inscripcion/DatosInscripcion";

class VerificacionPagoTable extends Component {
    state = {
        openNoAccept: false,
        openAccept: false,
        openModal: false,
        modalNoAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        modalAcceptBtn1: {
            icon:"fa fa-check",
            text: "Si",
            disabled: false
        },
        motivo :"",
        errorMess: "",
        factura: "",
        errorFact: "",
        qr: "",
        openMaterias: false
    }

    componentWillMount =  () => {
        
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase()
        });
    };

    modalAccept = () => {
        const { openAccept, modalAcceptBtn1, factura, errorFact } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-primary">APROBAR</strong> esta transacción de <strong>{formatNumber(this.props.datos.total)} Bs.{/*  | {formatReconver(this.props.datos.total)} Bs. */}?</strong></div>
                <div className="custom-alert-info" style={{padding:5}}>
                    <input type="text" value={factura} onChange={this.cambiaValor("factura")} className="form-control" placeholder="Número de la Factura"/>
                    <span className="text-danger">{errorFact}</span>
                </div>
                <div className="text-muted" style={{fontSize: 11}}>Se le  enviará una notificación al estudiante</div>
            </React.Fragment>
        )

        let Aceptar = (id) => (e) => {
            if (this.state.modalAcceptBtn1.disabled === true) return null

            if ((factura) === "") {
                this.setState({
                    factura : "",
                    errorFact: "Debes indicar el número de la factura"
                })
                return null;
            }

            this.setState({
                modalAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            AceptarTransaccion (id, factura, () => {
                this.setState ({
                    openAccept: false,
                    openModal: false,
                },() => {
                    toast.info("Has verificado correctamente la transacción",{autoClose: 4000});
                    this.props.updList();
                    this.setState({
                        modalNoAcceptBtn1: {
                            icon:"fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalAcceptBtn1.icon}></i> {modalAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {Aceptar(this.props.datos.id)}
                funcion2 = {() => {this.setState({openAccept: false})}}
            />
        );
    }

    modalNoAccept = () => {
        const { openNoAccept, modalNoAcceptBtn1, motivo, errorMess } = this.state;

        let contenido = () => (
            <React.Fragment>
                <div>¿Desea realmente <strong className="text-danger"> CANCELAR</strong> esta transacción de <strong>{formatNumber(this.props.datos.total)} Bs.{/*  | {formatReconver(this.props.datos.total)} Bs. */}?</strong></div>
                
                <div className="custom-alert-danger" style={{padding:5}}>
                    <input type="text" value={motivo} onChange={this.cambiaValor("motivo")} className="form-control" placeholder="Indica el motivo"/>
                    <span className="text-danger">{errorMess}</span>
                </div>
            </React.Fragment>
        )

        let noAceptar = (id) => (e) => {
            if (this.state.modalNoAcceptBtn1.disabled === true) return null

            if ((motivo) === "") {
                this.setState({
                    motivo : "",
                    errorMess: "Indica primero el motivo"
                })
                return null;
            }

            this.setState({
                modalNoAcceptBtn1: {
                    icon:"fa fa-spinner fa-spin",
                    text: "Espera",
                    disabled: true
                }
            })

            NoAceptarTransaccion (id, motivo, () => {
                this.setState ({
                    openNoAccept: false,
                    motivo : "",
                    errorMess: ""
                },() => {
                    toast.info("Has rechazado correctamente la transacción",{autoClose: 4000});
                    this.props.updList();
                    this.setState({
                        modalNoAcceptBtn1: {
                            icon:"fa fa-check",
                            text: "Si",
                            disabled: false
                        },
                    })
                });
            })
        }

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                boton1 = {<React.Fragment><i className={modalNoAcceptBtn1.icon}></i> {modalNoAcceptBtn1.text}</React.Fragment>}
                large = "medium"
                isopen =  {openNoAccept}
                titulo = "Confirmación"
                contenido = {contenido()}      
                funcion1 = {noAceptar(this.props.datos.id)}
                funcion2 = {() => {this.setState({openNoAccept: false})}}
            />
        );

    }

    modal = () => {
        let { openModal, qr } = this.state;
        if (openModal === false) return null;

        return (
            <ModalReports 
                reporte={<ReciboDePago
                    datos = {this.props.datos}
                    qrCode = {qr}
                />}
                titulo={"Impresión de Recibo de Pago"}
                display= "block"
                cerrar = {() => {this.setState({openModal:false})}}
            />
        )
    }

    modalInscripcion = () => {
        let {openMaterias} = this.state;

        let contenido = () => (
            <DatosInscripcion idEst={this.props.datos.id_est }
            tlf = {this.props.datos.tlf} cel = {this.props.datos.cel}
            email = {this.props.datos.email}
            EstCuenta ={true}/>
        )

        return (
            <CustomModal
                boton2 = {<React.Fragment><i className="fa fa-check"></i> Aceptar</React.Fragment>}
                boton1 = ""
                large = "large"
                isopen =  {openMaterias}
                titulo = {<div className="text-danger" style={{fontSize: 14}}>{`Materias Inscritas de ${this.props.datos.estudiante}`}</div>}
                contenido = {contenido()}      
                funcion2 = {() => {this.setState({openMaterias: false})}}
            />
        );
    }

    openReport = () => {
        let token = this.props.datos.token;

        let imgSvg = (
            <QRCode renderAs="svg" xmlns='http://www.w3.org/2000/svg' value={`https://iudlm.com/recibo?code=${token.substring(0,10)}`}/>
        )
        
        const svgString = encodeURIComponent(renderToStaticMarkup(imgSvg));
        const dataUri = `data:image/svg+xml;base64,${btoa(unescape(svgString))}`;

        SvgToPng (dataUri, (qr) => {
            this.setState({
                qr: qr,
                openNoAccept: false,
                openAccept: false,
                openModal: true
            })
        })
    }

    render() {
        let { datos } = this.props;

        const styles = {
            padding: 5, fontSize: 12
        }
        
        let menu = (
            <Popover bsSize="large" id="acciones">
                <div className="text-primary" onClick={() => {this.openReport()}} style={{cursor:"pointer", fontSize: 13, padding: 5}} title="Imprimir el recibo de pago de esta transacción"><i className="fa fa-print"></i> Recibo de Pago</div>
                <div className="text-success" onClick={() => {this.setState({openNoAccept: false, openAccept: true, openModal: false})}} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Aprobar esta transacción"><i className="fa fa-check-circle"></i> Aprobar Transacción</div>
                <div className="text-danger" onClick={() => {this.setState({openNoAccept: true, openAccept: false, openModal: false})}} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Rechazar esta transacción"><i className="fa fa-trash"></i> Cancelar Transacción</div>
                <div className="text-warning" onClick ={() => {this.setState({openMaterias:true})}} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Ver las Materias Inscritas"><i className="fa fa-address-book"></i> Ver Materias Inscritas</div>
            </Popover>
        )

        let transaccion = (obj) => (
            obj.map(option => (
                <div key= {option.id} style={{fontSize: 10}}>
                    <div>Fecha: <strong>{option.fecha}</strong></div>
                    <div>Banco: <strong>{option.banco}</strong></div>
                    <div>Descripcion: <strong className="text-danger">{option.item}</strong></div>
                    <div align="right">Monto: <strong className="text-danger">{formatNumber(option.haber)} Bs.{/*  | {formatReconver(option.haber)} Bs. */}</strong></div>
                </div>
            ))
        )

        return (
            <React.Fragment>
                <tr key={datos.id}>
                    <td style={{padding: 5, fontSize: 9}}>
                        <div>C.I.: <strong>{datos.ci}</strong></div>
                        <div className="text-danger"><strong>{datos.estudiante}</strong></div>
                    </td>
                    <td style={styles}>
                        <div>{transaccion(datos.transacciones)}</div>
                        <div align="right" style={{fontSize: 10}}>Método de Pago: <strong className="text-danger">{datos.metodo}</strong></div>
                        <div align="right" className="custom-alert-info" style={{marginTop: 4}}>Pagado: <strong className="text-danger">{formatNumber(datos.total)} Bs.{/*  | {formatReconver(datos.total)} Bs. */}</strong></div>
                    </td>
                    <td align="center" style={styles}>
                        <OverlayTrigger trigger="focus" placement="right" overlay={menu}>
                            <button className="btn btn-primary" title= "Haz click aqui para ver las opciones disponibles" style={{borderWidth: 1}}><i className="fa fa-chevron-right"></i></button>
                        </OverlayTrigger>
                    </td>
                </tr>
                {this.modalNoAccept()}
                {this.modalAccept()}
                {this.modal()}
                {this.modalInscripcion()}
            </React.Fragment>
        );
    }
}
 
export default VerificacionPagoTable;


// WEBPACK FOOTER //
// ./src/views/Administracion/EstadosCuentaContent/VerificacionPagoTable.jsx